import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'RequestSignInDetailsPage' })(() => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& > *': {
      marginBottom: 'var(--ebl-s2) !important',
    },
  },
  helpText: {
    marginBottom: '0px !important',
  },
}));
